export class GetUserRegions {
  static readonly type = '[User] User Get Regions';

  constructor(public forceRefresh = false) { }
}
